import React, { useEffect, useRef, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

interface Props {
  char: Character;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterInspirationButton({
  char,
}: Props) {
  const [inspiration, setInspiration] = useState(char.char_interface.inspiration);
  // const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    char.subscription_holder.subscribe("Resources", mounted, resourcesChanged);
  }, []);

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  const resourcesChanged = () => {
    setInspiration(char.char_interface.inspiration);
    // setReloading(true);
  }
  
  console.log("rendering");
  return (
    <div>
      <ToggleButtonBox 
        name="Heroic Inspiration"
        value={inspiration}
        style={{
          height: "16px",
          fontSize: "10px",
          lineHeight: "1.5",
        }}
        colors={{ backgroundColor: "blue", color: "White" }}
        onToggle={() => {
          setInspiration(!inspiration);
          char.char_interface.inspiration = !inspiration;
          char.changed();
          char_util.resourcesChanged(char);
        }}
      />
    </div>
  );
}
